<template>
    <div class="login-provider">
        <p>Loading...</p>
    </div>
</template>

<script>
import { Auth } from '@/services/auth';
import { initializeApp } from 'firebase/app'
import { getAuth, signInWithRedirect, getRedirectResult, GoogleAuthProvider } from "firebase/auth";

export default {
    name: "edc-login-provider",
    mounted() {
        const firebaseConfig = {
       apiKey: "AIzaSyAIlP3taBIHvbZ_HRE02uhTEHz-SpxPLz4",
        authDomain: "enamorate-c2b18.firebaseapp.com",
        databaseURL: "https://enamorate-c2b18-default-rtdb.firebaseio.com",
        projectId: "enamorate-c2b18",
        storageBucket: "enamorate-c2b18.firebasestorage.app",
        messagingSenderId: "121287424625",
        appId: "1:121287424625:web:0383f55345b2ec534e39d0",
        measurementId: "G-EX8GVRYNYW"
        };

        initializeApp(firebaseConfig);
        const provider = new GoogleAuthProvider();
        const auth = getAuth();

        getRedirectResult(auth)
        .then((result) => {
            console.log(result);
            if (result?.user != null) {
                result.user.getIdToken().then((token) => {
                    Auth.loginProvider(token).then(() => {
                        this.$router.push({ name: 'home' })
                    })
                })
            } else {
                signInWithRedirect(auth, provider)
                .then((result) => {
                    console.log(result)
                }).catch((error) => {
                    console.log(error)
                });
            }
        })
        
    }
}
</script>

<style>
.login-provider {
    padding: 24px;
}
</style>